<script
    context="module"
    lang="ts"
>
    import { overlays } from "../../store"
    import MobileMenuSubCategory from "./MobileMenuSubCategory.svelte"

    export function openSubmodule(element: NavigationElement) {
        overlays.update((o) => {
            const openedAtLvl = o.findIndex((overlay) => overlay.active)
            let overlays = o.map((overlay) => {
                overlay.active = false
                return overlay
            })
            overlays.splice(openedAtLvl + 1, overlays.length - openedAtLvl - 1)
            const subMenuOverlay: Overlay = {
                id: element.name,
                title: element.name,
                active: true,
                content: MobileMenuSubCategory,
                properties: {
                    element,
                },
            }
            return [...overlays, subMenuOverlay]
        })
    }
</script>

<script lang="ts">
    import { mdiChevronRight } from "@mdi/js"
    import { spaNavigate } from "../../actions"
    import Icon from "../widgets/Icon.svelte"

    export let elements: NavigationElement[], bannerVisible: boolean, scrolled: boolean

    const mainCategories = elements.filter((el) => el.type === "bigcommerce")
    let selectedCategory = mainCategories[0]
    const contentCategories = elements.filter((el) => el.type === "content")

    //menu übereinander stacken
</script>

<section id="mobileMenu">
    <section id="commerceCategories">
        <ul id="mainCategories">
            {#each mainCategories as mainCategory}
                <li>
                    <button
                        class="cta"
                        class:active="{selectedCategory.name === mainCategory.name}"
                        on:click="{() => {
                            selectedCategory = mainCategory
                        }}"
                    >
                        {mainCategory.name}
                    </button>
                </li>
            {/each}
        </ul>

        <ul id="subCategories">
            {#each selectedCategory.elements as subCategory}
                <li>
                    <button
                        class="cta"
                        on:click="{() => {
                            openSubmodule(subCategory)
                        }}"
                    >
                        <p>{subCategory.name}</p>
                        <Icon path="{mdiChevronRight}" />
                    </button>
                </li>
            {/each}
        </ul>
    </section>

    <section>
        <ul id="contentCategories">
            {#each contentCategories as contentCategory}
                <li>
                    <button
                        class="cta"
                        on:click="{() => {
                            if (contentCategory.elements?.length) openSubmodule(contentCategory)
                            else spaNavigate(contentCategory.page)
                        }}"
                    >
                        {contentCategory.name}
                    </button>
                </li>
            {/each}
        </ul>
    </section>
</section>

<style lang="less">
    #mobileMenu {
        width: 100%;
        height: 100%;
        button {
            color: var(--text-invers-100);
            width: 100%;
            text-transform: uppercase;
            font-family: "Outfit-Bold", sans-serif;
            font-weight: 700;
            font-size: 1rem;
        }
        #commerceCategories {
            display: flex;
            flex-direction: column;
            gap: 32px;
            #mainCategories {
                display: flex;
                gap: 0px;
                width: 100%;
                li {
                    width: 0px;
                    flex-grow: 1;
                    button {
                        background-color: transparent;
                        border: 1px solid var(--bg-100);

                        &.active {
                            background-color: var(--primary-100);
                            color: var(--text-100);
                        }
                    }
                    &:nth-child(1) {
                        button {
                            border-right: 0px solid black;
                        }
                    }
                    &:nth-child(2) {
                        button {
                            border-left: 0px solid black;
                        }
                    }
                }
            }

            #subCategories {
                display: flex;
                flex-direction: column;
                gap: 12px;
                li {
                    button {
                        background-color: var(--bg-300);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                }
            }
        }
    }
</style>
